import 'css-chunk:src/feature/payment/PartialPaymentModal.module.scss';export default {
  "form": "PartialPaymentModal_form"
};